import { call, select } from 'redux-saga/effects';
import { selectUserById } from 'features/users/usersSlice';
import { User } from 'features/users/types';
import { RTCClient } from 'utils/webrtc';
import i18n from 'i18n';
import { logger } from 'utils/logger';
import { notification } from 'features/notifications/toast/notification';
import { screenshareStoppedRemotely } from 'features/screenshare/actions';

export function* onScreensharingStoppedRemotelySaga(
  action: ReturnType<typeof screenshareStoppedRemotely>
) {
  logger
    .remote({ tier: 1 })
    .info(`Screen sharing stopped remotely by user id=${action.payload.initiator.id}`);

  const user: User = yield select(selectUserById, action.payload.initiator.id);
  if (user?.name) {
    yield call(
      notification,
      i18n.t('notifications:screen_sharing_stopped_remotely', { username: user.name })
    );
  } else {
    yield call(notification, i18n.t('notifications:screen_sharing_stopped_remotely_unnamed'));
  }

  yield call(RTCClient.screensharingFeed.stopScreenshare);
}
